import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

const getters = {
    user: (state) => state.user.user,
    name: (state) => state.user.user ? state.user.user.name : '',
    phone: (state) => state.user.user ? state.user.user.phone : '',
    sex: (state) => state.user.user ? state.user.user.sex : '0',
    orgDepartmentList: (state) => state.user.user ? state.user.user.orgDepartmentList : null,
    member: (state) => state.user.member
};

export default new Vuex.Store({
    modules: {
        user,
    },
    getters
})


// WEBPACK FOOTER //
// ./src/store/index.js